<input type="file" [name]="fileId" [id]="fileId" class="form-control inputfile" />
<label [for]="fileId" class="btn btn-primary btn-sm"><span>Choose File</span></label>
